module.exports = __webpack_public_path__ + "media/PAG64-08.0f98aa82.mp3";